export default __webpack_public_path__ + "static/media/20160821-GlassesFace-Trans-Back.b81f0231.png";